import Vue from 'vue'
import { fixedFloat, replaceFloat, replaceInt, tryToInt } from './functions'
/*
 *  定义公共js里，在入口文件main.js中import；
 *  给elementUI的dialog上加上 v-dialogDrag 指令就可以实现弹窗的全屏和拉伸了。
 */
// v-dialogDrag: 弹窗拖拽+水平方向伸缩
Vue.directive('dialogDrag', {
  bind(el: any, binding: any, vnode: any, oldVnode: any) {
    //弹框可拉伸最小宽高
    let minWidth: number = 400
    let minHeight: number = 300
    //初始非全屏
    let isFullScreen: boolean = false
    //当前宽高
    let nowWidth: number = 0
    let nowHight: number = 0
    //当前顶部高度
    let nowMarginTop: number = 0
    //获取弹框头部（这部分可双击全屏）
    const dialogHeaderEl: any = el.querySelector('.el-dialog__header')
    //弹窗
    const dragDom: any = el.querySelector('.el-dialog')
    //给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    dragDom.style.overflow = 'auto'
    //清除选择头部文字效果
    dialogHeaderEl.onselectstart = new Function('return false')
    //头部加上可拖动cursor
    dialogHeaderEl.style.cursor = 'move'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null)
    const sty: any = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    let moveDown = (e: any) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX: number = e.clientX - dialogHeaderEl.offsetLeft
      const disY: number = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL: any, styT: any
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }

      document.onmousemove = function (e: any) {
        // 通过事件委托，计算移动的距离 
        const l: number = e.clientX - disX
        const t: number = e.clientY - disY

        // 移动当前元素  
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`

        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function (e: any) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
    dialogHeaderEl.onmousedown = moveDown
    //双击头部效果
    dialogHeaderEl.ondblclick = (e: any) => {
      if (isFullScreen == false) {
        nowHight = dragDom.clientHeight
        nowWidth = dragDom.clientWidth
        nowMarginTop = dragDom.style.marginTop
        dragDom.style.left = 0
        dragDom.style.top = 0
        dragDom.style.height = '100VH'
        dragDom.style.width = '100VW'
        dragDom.style.marginTop = 0
        isFullScreen = true
        dialogHeaderEl.style.cursor = 'initial'
        dialogHeaderEl.onmousedown = null
      } else {
        dragDom.style.height = 'auto'
        dragDom.style.width = nowWidth + 'px'
        dragDom.style.marginTop = nowMarginTop
        isFullScreen = false
        dialogHeaderEl.style.cursor = 'move'
        dialogHeaderEl.onmousedown = moveDown
      }
    }

    //拉伸
    let resizeEl: HTMLDivElement = document.createElement('div')
    dragDom.appendChild(resizeEl)
    //在弹窗右下角加上一个10-10px的控制块
    resizeEl.style.cursor = 'se-resize'
    resizeEl.style.position = 'absolute'
    resizeEl.style.height = '10px'
    resizeEl.style.width = '10px'
    resizeEl.style.right = '0px'
    resizeEl.style.bottom = '0px'
    //鼠标拉伸弹窗
    resizeEl.onmousedown = (e: any) => {
      // 记录初始x位置
      const clientX = e.clientX
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - resizeEl.offsetLeft
      const disY = e.clientY - resizeEl.offsetTop

      document.onmousemove = function (e: any) {
        e.preventDefault() // 移动时禁用默认事件
        // 通过事件委托，计算移动的距离 
        const x = e.clientX - disX + (e.clientX - clientX)//这里 由于elementUI的dialog控制居中的，所以水平拉伸效果是双倍
        const y = e.clientY - disY
        //比较是否小于最小宽高
        dragDom.style.width = x > minWidth ? `${x}px` : minWidth + 'px'
        dragDom.style.height = y > minHeight ? `${y}px` : minHeight + 'px'
      }
      //拉伸结束
      document.onmouseup = function (e: any) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
/**
 *  注意：如果是el-dialog弹出的表单el-form，最好不要把提交按钮当做el-form-item（elementUI文档是这么用的），放在el-dialog里。
 *  不然按钮会同el-dialog中标签一样被overflow；
*/

/*防止按钮多次点击 
用法
<button v-dbClick />
*/
Vue.directive('dbClick', {
  inserted(el: any, binding: any) {
    el.addEventListener('click', (e: any) => {
      if (!el.disabled) {
        el.disabled = true
        let timer = setTimeout(() => {
          el.disabled = false
        }, 2000)
      }
    })
  }
})

/*
表格无限滚动
用法：v-tableLoadMore:fn='scope.row'
其中fn为自定义函数，后面为fn需要传递的参数。
**实例：设备数据=>子级的表格滚动加载数据**
*/
Vue.directive('tableLoadMore', {
  bind(el: any, binding: any, vnode: any) {
    var p = 0
    var t = 0
    var down = false
    var selectWrap: Element = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', (e: any) => {
      var _this = e.target
      p = _this.scrollTop
      if (t < p) {
        down = true
      }
      else {
        down = false
      }
      t = p
      //判断是否到底 
      const sign = 10
      const scrollDistance = _this.scrollHeight - _this.scrollTop - _this.clientHeight
      if (scrollDistance <= sign && down) {
        let that = vnode.context
        that[binding.arg](binding.value)
        // binding.value()
      }
    })
  }
})

/*
body、div等有滚动条的元素，在滚动条拉到最下面的时候自动加载数据，实现无限滚动加载
用法：v-scrollMore:函数='参数'
*/
Vue.directive('scrollMore', {
  bind(el: any | Element, binding: any, vnode: any) {
    var p = 0
    var t = 0
    var down = false
    el.addEventListener('scroll', (e: any) => {
      var _this = e.target
      p = _this.scrollTop
      if (t < p) {
        down = true
      }
      else {
        down = false
      }
      t = p
      //判断是否到底 
      const sign = 10
      const scrollDistance = _this.scrollHeight - _this.scrollTop - _this.clientHeight
      if (scrollDistance <= sign && down) {
        let that = vnode.context
        that[binding.arg](binding.value)
        // binding.value()
      }
    })
  }
})
/*
按字节数截取输入的文字，中文占两个字节
用法: v-byteLen="20"
*/
Vue.directive('byteLen', {
  inserted(el: any, binding: any, vnode: any) {
    const setVal = (val: any) => {
      if (vnode.componentInstance) {
        // 如果是自定义组件就触发自定义组件的input事件
        vnode.componentInstance.$emit('input', val)
      } else {
        // 如果是原生组件就触发原生组件的input事件
        el.value = val
        el.dispatchEvent(new Event('input'))
      }
    }
    //截取字符
    const cutVal = (value: any, maxLen: number): any => {
      const len = value.replace(/[^\x00-\xff]/g, '01').length
      if (len > maxLen) {
        value = value.substring(0, value.length - 1)
        return cutVal(value, maxLen)
      }
      return value
    }
    //校验输入的字符
    const checkVal = (event: any) => {
      const e = event || window.event
      let value = e.target.value
      const maxLen = binding.value
      setVal(cutVal(value, maxLen))
    }

    // el.addEventListener('keypress', (event: any) => {
    //   checkVal(event)
    // })
    el.addEventListener('keyup', (event: any) => {
      checkVal(event)
    })
    el.addEventListener('focusout', (event: any) => {
      checkVal(event)
    })
  }
})
/** v-enterInt 只能输入整数 */
Vue.directive('enterInt', {
  inserted(el: any, binding: any, vnode: any) {
    const setVal = (val: any) => {
      console.log(val)
      if (vnode.componentInstance) {
        // 如果是自定义组件就触发自定义组件的input事件
        vnode.componentInstance.$emit('input', val)
      } else {
        // 如果是原生组件就触发原生组件的input事件
        el.value = val
        el.dispatchEvent(new Event('input'))
      }
    }
    const formatValue = (val: any) => {
      //强制转为float格式，去掉数字和点之外的字符
      var newVal = val ? replaceInt(val) : ''
      return tryToInt(newVal)
    }

    //校验输入的字符
    const checkVal = (event: any) => {
      const e = event || window.event
      let value = e.target.value
      value = formatValue(value)
      return value
    }

    el.addEventListener('keypress', (event: any) => {
      setVal(checkVal(event))
    })
    // el.addEventListener('keyup', (event: any) => {
    //   checkVal(event)
    // })
    el.addEventListener('focusout', (event: any) => {
      setVal(checkVal(event))
    })
  }
})
/** v-enterFloat 只能输入浮点数，数字和小数点 */
Vue.directive('enterFloat', {
  inserted(el: any, binding: any, vnode: any) {    
    //console.log(binding.value)
    const setVal = (val: any) => {
      if (vnode.componentInstance) {
        // 如果是自定义组件就触发自定义组件的input事件
        vnode.componentInstance.$emit('input', val)
      } else {
        // 如果是原生组件就触发原生组件的input事件
        el.value = val
        el.dispatchEvent(new Event('input'))
      }
    }
    const formatValue = (val: any) => {
      //强制转为float格式，去掉数字和点之外的字符
      var newVal = val ? replaceFloat(val) : ''
      // var v = tryToFloat(newVal)
      return newVal
    }

    //校验输入的字符
    const checkVal = (event: any) => {
      const e = event || window.event
      let value = e.target.value
      value = formatValue(value)
      return value
    }
    const compareVal = (event: any) => {
      var val = checkVal(event)
      var bd = binding.value
      //console.log(val, bd)
      if (bd && bd.max) {
        if (val > bd.max) {
          val = bd.max
        }
      }
      if (bd && bd.min) {
        if (val < bd.min) {
          val = bd.min
        }
      }
      return val
    }
    el.addEventListener('keypress', (event: any) => {
      setVal(checkVal(event))
    })
    // el.addEventListener('keyup', (event: any) => {
    //   checkVal(event)
    // })
    el.addEventListener('focusout', (event: any) => {
      setVal(fixedFloat(compareVal(event)))
    })
  }
})